import { action } from 'mobx';
import i18next from 'i18next';

import { AppManager, Variables } from 'core/index';

import { ProjectConnManager } from 'apps/project/connManager';
import { CommunityProjectsQuery } from 'apps/project/gql';

export default class CommunityProjectsManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.variables = new Variables({
      projectsCursor: () => null,
      projectsSortBy: () => this.projectsConn.sortBy,
      projectsCount: () => this.projectsConn.variables.batchSize,
      projectsFilterBy: () => this.projectsConn.variables.filterBy,
    });
    this.projectsConn = new ProjectConnManager(this, {
      sortBy: 'discover_recent',
      sortOptions: [
        ['discover_recent', i18next.t('Recent')],
        ['followers', i18next.t('Followers')],
        ['contributions', i18next.t('Contributions')],
        ['pageviews', i18next.t('Views')],
      ],
      initialBatchSize: 12,
      loadMoreQuery: CommunityProjectsQuery,
    });
    this.ProjectsQuery();
    this.projectsConn.QueryAllPhases();
  }

  @action ProjectsQuery = () => {
    this.projectsConn.loadMore();
  };
}
